import { getStrapiResponse } from "../../utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { Pages_Plain } from "../../types/api/page.ts";
import "../../components/Pages/Pages.scss";
import remarkGfm from "remark-gfm";
import Markdown from "react-markdown";
import Page404 from "../../components/Page404/Page404.tsx";

const fetchPageData = async ({
  queryKey,
}: {
  queryKey: string[];
}): Promise<Pages_Plain> => {
  const response = await getStrapiResponse(queryKey[0]);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

const PagesUkraine = ({ locale }: { locale: string }) => {
  const navigate = useNavigate();
  const params = useParams();
  const pageUrl = `/api/page-ukraines?customPopulate=nested&filters[slug][$eq]=${
    params.slug ? params.slug : ""
  }&locale=${locale}`;

  const {
    data: pages,
    error,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [pageUrl],
    queryFn: fetchPageData,
  });

  if (isLoading) return <div className="loading-block"></div>;
  if (isError) return <div>Error: {error.message}</div>;
  if (!pages) return <div>Global error: {pages}</div>;
  if (!pages.data.length) {
    navigate("/" + locale, { replace: true });
    return <Page404 locale={locale} />;
  }

  const page = pages.data[0];
  return (
    <>
      <div className="content-block">
        <div className="text-page">
          <div className="wrapper">
            <h1>{page.title}</h1>
            <div className="text-page__wrap">
              <div className="text-page__cont">
                {page.tabs[0] ? (
                  <Markdown remarkPlugins={[remarkGfm]}>
                    {page.tabs[0]?.text}
                  </Markdown>
                ) : (
                  ""
                )}
              </div>
              <div className="text-page__wrap-left">
                <p dangerouslySetInnerHTML={{ __html: page.textLeft }}></p>
              </div>
              <div className="text-page__wrap-right">
                <p>{page.textRight}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PagesUkraine;
